import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ClientService } from "../service/client.service";
import { ClientModel } from "../model/clientModel";
import { CallTypeModel } from "../model/callType";
import { SupportCallModel } from "../model/SupportCallModel";
import { NgForm } from "@angular/forms";
import { NewCallRequest } from "../model/newCallRequest";
import { Supplier } from "../model/supplier";

@Component({
  selector: "app-client-details",
  templateUrl: "./client-details.component.html",
  styleUrls: ["./client-details.component.css"],
})
export class ClientDetailsComponent implements OnInit {
  client: ClientModel | null = null;
  isLoading = false;
  loadError: string | null = null;

  callTypes: CallTypeModel[] = [];
  selectedCallTypeId: number | null = null;

  clientId: number;

  calls: SupportCallModel[] = [];

  showSupportCalls = false;

  newCall: NewCallRequest;

  suppliers: Supplier[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private clientService: ClientService,
  ) {}

  ngOnInit() {
    this.loadClient();
    this.loadCallTypes();
    this.getAllRelatedCalls();
  }

  loadClient() {
    const idParam = this.route.snapshot.paramMap.get("id");
    if (!idParam) {
      this.loadError = "Client id is missing.";
      return;
    }

    this.clientId = +idParam; // convert to number

    if (isNaN(this.clientId)) {
      this.loadError = "Client id is invalid.";
      return;
    }

    this.isLoading = true;
    this.loadError = null;

    this.clientService.getClientById(this.clientId).subscribe(
      (response: ClientModel) => {
        console.log("Client details:", response);
        this.client = response;
        this.isLoading = false;
      },
      (error) => {
        console.error("Error loading client details:", error);
        this.loadError = "Failed to load client details.";
        this.isLoading = false;
      },
    );
  }

  loadCallTypes() {
    this.clientService.getAllCallTypes().subscribe(
      (response) => {
        console.log("Call types:", response);
        this.callTypes = response;
      },
      (error) => console.log(error),
    );
  }

  getAllRelatedCalls = () => {
    this.clientService.getAllRelatedCalls(this.clientId).subscribe(
      (response) => {
        this.calls = response;
        console.log("calls:", this.calls);
      },
      (error) => {
        console.log(error);
      },
    );
  };

  newCallRequest = () => {
    this.showSupportCalls = !this.showSupportCalls;
  };

  submit(callForm: NgForm) {
    if (callForm.invalid) {
      return;
    }
    this.newCall = callForm.value;
    this.newCall.ClientId = this.clientId;
    console.log("newCall", this.newCall);

    this.clientService.addNewCallRequest(this.newCall).subscribe(
      (response) => {
        console.log(response);
        if (response) {
          alert("הפניה נישמרה בהצלחה!");
          this.getAllRelatedCalls();
          this.showSupportCalls = false;
          callForm.resetForm();
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  onCallTypeChange(callTypeId: string) {
    this.selectedCallTypeId = +callTypeId;
    console.log("Selected call type:", this.selectedCallTypeId);
  }

  goToCallDetails = (callId: number) => {
    console.log("Navigating to call details:", callId);
    this.router.navigate(["/callRequestDetails", callId]);
  };

  toggleCallStatus = (callId: number) => {
    if (!confirm("האם אתה בטוח שברצונך לסגור/לפתוח את הפניה?")) {
      return;
    }

    console.log("Closing callId:", callId);

    this.clientService.toggleCallStatus(callId).subscribe(
      (res: boolean) => {
        if (res) {
          alert("הפניה נסגרה/נפתחה בהצלחה");
          this.getAllRelatedCalls();
        } else {
          alert("משהו השתבש...");
        }
      },
      (err) => {
        console.error(err);
        alert("שגיאת שרת");
      },
    );
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/client-details/client-details.component.ts